const ENABLE_FINANCIAL_PLAN_SOURCE = process.env.REACT_APP_ENABLE_FINANCIAL_PLAN_SOURCE === 'true'
const ENABLE_PORTFOLIO_MANAGER = process.env.REACT_APP_ENABLE_PORTFOLIO_MANAGER === 'true'

export const flags = {
    financialPlanSource: ENABLE_FINANCIAL_PLAN_SOURCE,
    portfolioManager: ENABLE_PORTFOLIO_MANAGER
};